import { PagesBanner, Projects } from "../components";

export default function ProjectsPage() {
  return (
    <>
      <PagesBanner
        title="Client Focused Projects"
        description="At Innovation Academy, we prioritize our clients’ needs by delivering
          customized solutions through hands-on student involvement."
      />
      <Projects category="client" />
      <PagesBanner
        title="Student Projects"
        description="Our students work directly with clients to deliver real-world
          solutions."
      />
      <Projects category="student" />
    </>
  );
}
